import React from 'react';
import { Link } from 'react-router-dom';

export const navItems = [
	{
		name: 'who',
		title: 'Who we are',
	},
	{
		name: 'why',
		title: 'Why we do this',
	},
	{
		name: 'founders',
		title: 'Our founders',
	},
	{
		name: 'join',
		title: 'Join our team',
	},
	{
		name: 'organizations',
		title: 'Organizations',
	},
];

// eslint-disable-next-line max-len
export const mastHeadText = 'I leave an appointment with a trail of grieving people in my wake, and I feel a glow of satisfaction and rightness and karmic return because I know that I have done good and profound work.';

export const whoBlockTitle = 'We believe all pets deserve peaceful end-of-life experiences';

export const whoBlockText = (
	<>
		Lap of Love is a network of veterinarians around the country with the goal of empowering every owner to care for their geriatric pets. Our
		philosophy centers around the human-animal bond and the need for that bond to be as undisturbed as possible during this most difficult time.
		The desire to bring this important service to families across the United States is slowly being realized as additional veterinarians begin
		working under the same philosophy. Lap of Love is honored to have some of the most compassionate and empathetic vets working with us.
		<br />
		<br />
		At Lap of Love, we firmly believe in the inherent value of diversity and inclusivity and are committed to providing our services with respect,
		compassion, dignity, and equality for all families that reach out to us!
	</>
);

export const whyBlockTitle = "Because pets are family. That's why we do this. ";

// eslint-disable-next-line max-len
export const whyBlockText = 'Any veterinarian who chooses to dedicate his or her life to the practice of veterinary hospice and euthanasia is incredibly special. This may not be an easy role to play in our society, but we all respond the same way when asked why we do this: because pets are family, and this is an honor. At Lap of Love, our nationwide network of doctors is in constant communication with each other. Not only are we continually discussing new medical protocols for achieving the best possible outcomes (whatever that may be) for our patients, but we are also the industry leaders in this new and evolving field of veterinary medicine. Plus, we\'re animals lovers, too—we\'ve dedicated our lives to helping the creatures we share this planet with. And yes, we know what it feels like to lose a family member… grief is grief, no matter what species it is! ';

export const creationStorySlidesContent = [
	{
		year: '2009',
		title: '',
		message: (
			<>
				Dr. Dani McVety started Lap of Love Veterinary Hospice shortly after graduating from veterinary school while practicing emergency
				medicine in her hometown of Tampa, FL. After helping countless families through the loss of their pets, she felt an immense
				inspiration to combine her previous experience as a human hospice volunteer with her love of people and a desire to make the
				experience of losing a pet as peaceful as it can possibly be.
			</>
		),
	},
	{
		year: '2010',
		title: '',
		message: (
			<>
				Lap of Love grew quickly as word spread about a new way for pet parents to say goodbye. Dr. McVety began receiving calls and emails
				from families and veterinarians nationwide looking for similar services in their area. It was quickly apparent that Lap of Love was
				meant to be bigger than just Tampa, Florida! Dr. McVety contacted her good friend and veterinary school classmate, Dr. Mary Gardner,
				to help expand Lap of Love nationwide. Dr. Gardner immediately felt the connection with Lap of Love’s service and
				{' '}
				<a href="https://www.youtube.com/watch?v=tqG5yD2I4TA" target="_blank" className="inline-link" rel="noopener noreferrer">
					joined as co-founder
				</a>
				, applying her decade of software design experience to lead the development of the company’s proprietary practice management software.
			</>
		),
	},
	{
		year: '2011',
		title: '',
		message: <>Lap of Love welcomes their first veterinarian outside Florida, in Charlotte, North Carolina.</>,
	},
	{
		year: '2013',
		title: '',
		message: (
			<>
				Lap of Love expands to serve 20 states across the country.
				<br />
				<br />
				Drs McVety and Gardner teach multiple hours at the University of Florida College of Veterinary Medicine’s first End of Life course
				offered to senior veterinary students, focused specifically on hospice and euthanasia of all animal species. They have helped teach
				the course every year since.
			</>
		),
	},
	{
		year: '2015',
		title: '',
		message: (
			<>
				{' '}
				As our service grew, we knew our doctors needed help answering phone calls from families requesting assistance. In 2015 we established
				our dedicated
				{' '}
				<Link to="/about-us/support-center-team" target="_blank" className="inline-link" rel="noopener noreferrer">
					Support Center
				</Link>
				{' '}
				with a team of compassionate professionals to assist families over the phone.
				<br />
				<br />
				Lap of Love ranks 29 on the Gator100, a list of the world’s fastest-growing companies led by University of Florida graduates.
			</>
		),
	},
	{
		year: '2016',
		title: '',
		message: <>Lap of Love ranks 45 on the Gator100, a list of the world’s fastest-growing companies led by University of Florida graduates.</>,
	},
	{
		year: '2017',
		title: '',
		message: (
			<>
				Lap of Love’s team grows to over 100 doctors nationwide!
				<br />
				<br />
				Lap of Love has been honored to sit at the bedside of more than 100,000 pets and their families, assisting in the peaceful and loving
				transition of euthanasia since the company was founded in 2009.
				<br />
				<br />
				Lap of Love ranks 76 on the Gator100, a list of the world’s fastest-growing companies led by University of Florida graduates.
			</>
		),
	},
	{
		year: '2018',
		title: '',
		message: (
			<>
				Lap of Love expands to serve 30 states across the country.
				<br />
				<br />
				Lap of Love ranks 19 on the Gator100, a list of the world’s fastest-growing companies led by University of Florida graduates.
				<br />
				<br />
				Lap of Love receives the first-ever Innovative Practice of the Year award from the Veterinary Innovation Council, a division of the
				North American Veterinary Community. Lap of Love is awarded Best in Show by the Veterinary Innovation Council for receiving more votes
				than any nominee in any category.
				<br />
				<br />
				Lap of Love ranks 1956 on the 2018 Inc. 5000 list of the fastest-growing private companies in America.
			</>
		),
	},
	{
		year: '2019',
		title: '',
		message: (
			<>
				Lap of Love ranks 11 on the Gator100, a list of the world’s fastest-growing companies led by University of Florida graduates, our
				highest ranking to date!
			</>
		),
	},
	{
		year: '2020',
		title: '',
		message: (
			<>
				As COVID descended upon the world, Lap of Love quickly rolled out a
				{' '}
				<Link to="/our-services/telehospice" className="inline-link" target="_blank" rel="noopener noreferrer">
					Telehospice service
				</Link>
				, providing telemedical advice to families nationwide via an in-depth
				{' '}
				<Link to="/quality-of-life-assessment" className="inline-link" target="_blank" rel="noopener noreferrer">
					Quality of Life
				</Link>
				{' '}
				conversation with our hospice veterinarians.
				<br />
				<br />
				Lap of Love’s team grows to over 200 doctors nationwide!
				<br />
				<br />
				As of 2020, Lap of Love has been honored to sit at the bedside of more than 250,000 pets and their families, assisting in the peaceful
				and loving transition of euthanasia.
				<br />
				<br />
				Lap of Love provides over 149 hours of end-of-life care lectures at industry conferences and 30 hours of lectures to veterinary
				colleges nationwide.
				<br />
				<br />
				Lap of Love ranks 19 on the Gator100, a list of the world’s fastest-growing companies led by University of Florida graduates.
			</>
		),
	},
	{
		year: '2021',
		title: '',
		message: (
			<>
				As of 2021, Lap of Love has been honored to sit at the bedside of more than 400,000 pets and their families, assisting in the peaceful
				and loving transition of euthanasia.
				<br />
				<br />
				Lap of Love launches dedicated
				{' '}
				<Link to="/our-services/pet-loss-support" className="inline-link" target="_blank" rel="noopener noreferrer">
					Pet Loss Support services
				</Link>
				{' '}
				for anyone who has experienced the loss of a pet.
				<br />
				<br />
				Lap of Love launches a
				{' '}
				<Link to="/blog" className="inline-link" target="_blank" rel="noopener noreferrer">
					Senior Pet Care blog
				</Link>
				.
				<br />
				<br />
				Lap of Love provides over 130 hours of end-of-life care lectures at industry conferences and 40 hours of lectures to veterinary
				colleges nationwide.
				<br />
				<br />
				Lap of Love ranks 87 on the Gator100, a list of the world’s fastest-growing companies led by University of Florida graduates.
			</>
		),
	},
	{
		year: '2022',
		title: '',
		message: (
			<>
				Lap of Love ranks 61 on the Gator100, a list of the world’s fastest-growing companies led by University of Florida graduates. This
				marks the 8th consecutive year Lap of Love has been on the Gator100, the ONLY company to achieve this feat!
				<br />
				<br />
				Lap of Love is featured in the award-winning documentary “The Hardest Day.” The film focuses on the power of the human-animal bond in
				its last moments and those who help navigate along the way.
			</>
		),
	},
	{
		year: '2023',
		title: '',
		message: (
			<>
				Lap of Love ranks 24 on the Gator100, a list of the world’s fastest-growing companies led by University of Florida graduates.
				<br />
				<br />
				Lap of Love’s team grows to over 300 doctors nationwide!
				<br />
				<br />
				Lap of Love launches an internal Certified Veterinary Hospice and Euthanasia Practitioner course. This is the most rigorous
				certification process solely focused on end-of-life veterinary care at this time.
			</>
		),
	},
];

// eslint-disable-next-line max-len
export const videoText = 'Pets are our best friends. They pick us up when we are down, and they never, ever take a day off from being by our side. And this is why pets deserve a peaceful and personal end-of-life experience. This is why we help them leave this earthly existence the way they want to—in the comfort of their homes, in the warm embrace of their favorite people.';
export const videoSrc = 'https://www.youtube.com/embed/tqG5yD2I4TA?showinfo=0';
export const videoTitle = "It's an honor to provide pets with peaceful end-of-life experiences.";

// eslint-disable-next-line max-len
export const blockRichText = 'We do this because we\'re naturally drawn to celebrating the amazing powers of the human-animal bond. And for us, there\'s no better way to honor that than to ensure pets have a peaceful end-of-life experience.';
export const linkMoreCaption = [
	{
		name: 'View Lap of Love opportunities',
		path: 'https://lapoflovejobs.workable.com',
	},
];
